import APIV5 from '~/models/api';
import { Confirm } from '~/scripts/services/modal/modal';

export default class AdminKiaDoctypeController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IIntervalService} $interval
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('~/scripts/services/ktranslate').KTranslate} KTranslate
	 * @param {any} Notification
	 */
	constructor(
		$injector,
		$interval,
		$scope,
		$timeout,
		$translate,
		KTranslate,
		Notification,
	) {
		this.$injector = $injector;
		this.$interval = $interval;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.KTranslate = KTranslate;
		this.Notification = Notification;

		/**
		 * @type {import('angular').IPromise<any> | undefined}
		 */
		this.check = undefined;

		/**
		 * @type {?(import('@knitiv/api-client-javascript/src/models/kia/doctype').KiaDocTypeDbListItem & {models: any[]})}
		 */
		this.database = null;

		/**
		 * @type {any[]}
		 */
		this.databases = [];

		/**
		 * @type {{kid: import('@knitiv/api-client-javascript').KNode, name: string}[]}
		 */
		this.doctypes = [];

		/**
		 * @type {boolean}
		 */
		this.loading = false;

		/**
		 * @type {import('~/components/mf/mf.controller').MfOptions}
		 */
		this.mfDocTypesOptions = {
			displayValues: true,
			displayExpandButton: false,
			displaySuggestBtn: true,
			multipleSelection: true,
		};

		this.tabActive = 0;

		(async () => this.loadDatabases())();
	}

	cancel() {
		this.database = null;
	}

	/**
	 * @param {number} jobId
	 * @param {any} model
	 */
	async checkJob(jobId, model) {
		/** @type {any} */
		const job = await APIV5.instance.kiaDocTypeJobInfo({
			job_id: jobId,
		}, {
			id: 'admin-kia-doctype.check-job',
		});
		this.$timeout(() => {
			model.progress = Math.round(job.progress);
			if (job.status === 'error') {
				model.status = 'error';
				if (this.check) {
					this.$interval.cancel(this.check);
				}
				this.Notification.error({
					title:   this.$translate.instant('error.title'),
					message: job.response,
				});
			}
			else {
				if (job.response?.status) {
					model.status = job.response.status;
				}
				if (model.status === 'ready' && this.check) {
					this.$interval.cancel(this.check);
					this.Notification.info({
						title:   this.$translate.instant('common.info'),
						message: 'Modèlé entraîné avec succès',
					});
				}
			}
		});
	}

	/**
	 * @param {any} model
	 * @param {number} index
	 */
	async deleteModel(model, index) {
		const modal = new Confirm(this.$injector);
		const answer = await modal.open({
			title:  'Suppression du modèle',
			body:   '<p>Êtes-vous sûr de vouloir supprimer ce modèle ?</p>',
			cancel: {
				label: this.$translate.instant('common.cancel'),
				type:  'default',
			},
			accept: {
				label: this.$translate.instant('common.delete'),
				type:  'danger',
			},
		});

		if (answer) {
			const deleteModelResult = await APIV5.instance.kiaDocTypeModelDelete({
				model_id: model.id,
			}, {
				id: 'admin-kia-doctype.delete-model',
			});
			this.$timeout(() => {
				if (deleteModelResult.deleted) {
					this.database?.models.splice(index, 1);
				}
			});
		}
	}

	/**
	 * @returns {Promise<void>}
	 */
	async loadDatabases() {
		this.loading = true;
		const databaseList = await APIV5.instance.kiaDocTypeDbList({ id: 'admin-kia-doctype.load-databases' });
		const result = await APIV5.instance.kiaDocTypeModelList(
			{},
			{ id: 'admin-kia-doctype.load-databases' },
		);
		this.loading = false;
		this.databases = databaseList.databases.map(database => ({
			...database,
			// @ts-ignore
			models: result?.models
				.filter(model => database.dsnasso_kid === model.dsnasso_kid)
				.map(model => {
					if (model.status === 'training' && model.job) {
						this.check = this.$interval(
							// @ts-ignore
							() => this.checkJob(model.job, model),
							1500,
						);
					}
					return model;
				}),
			status: 'active',
		}));

		// add missing databases from models
		// @ts-ignore
		if (result?.message) {
			// @ts-ignore
			const otherDatabases = result.message.filter(
				(/** @type {any} */ model) => !this.databases.some(d => d.dsnasso_kid === model.dsnasso_kid),
			);
			for (const d of otherDatabases) {
				const doctypes = await Promise.all(
					d.doctypes.map(async (
						/** @type {import('@knitiv/api-client-javascript').KNode} */ kid,
					) => ({ kid, name: await this.KTranslate.request(null, kid) })),
				);
				this.databases.push({
					...d,
					doctypes,
					models: [d],
					status: 'inactive',
				});
			}
		}
		this.$timeout(() => this.$scope.$apply());
	}

	/**
	 * @param {any} database
	 */
	async selectDatabase(database) {
		this.database = database;
		this.doctypes.length = 0;
	}

	/**
	 * @returns {Promise<void>}
	 */
	async submit() {
		if (this.database) {
			const resultSave = await APIV5.instance.kiaDocTypeModelSave({
				database:    {
					kid:  this.database.kid,
					name: this.database.name,
				},
				doctypes:    this.doctypes.map(d => d.kid),
				dsnasso_kid: this.database.dsnasso_kid,
			}, { id: 'admin-kia-doctype.submit' });
			if (resultSave) {
				const modelInfo = await APIV5.instance.kiaDocTypeModelInfo({
					model_id: resultSave.model_id,
				}, {
					id: 'admin-kia-doctype.submit',
				});
				if (modelInfo) {
					this.database.models.push(modelInfo);
					this.Notification.info({
						title:   this.$translate.instant('common.info'),
						message: 'Modèlé créé avec succès',
					});
					this.$timeout(() => {
						this.doctypes.length = 0;
					});
				}
			}
		}
	}

	/**
	 * @param {any} model
	 * @returns {Promise<void>}
	 */
	async trainModel(model) {
		model.progress = 0;
		return this.$timeout(async () => {
			try {
				model.status = 'training';
				const modelCreateResponse = await APIV5.instance.kiaDocTypeModelCreate({
					dsnasso_kid: model.dsnasso_kid,
					model_id:    model.id,
				}, {
					id: 'admin-kia-doctype.train-model',
				});
				// @ts-ignore
				const jobId = modelCreateResponse?.job_id;
				this.check = this.$interval(
					() => this.checkJob(jobId, model),
					1500,
				);
			}
			catch (error) {
				model.status = 'error';
				console.error(error);
			}
		});
	}
}
